import { KContext } from "@context"
import { EUrlPath } from "@types"
import { getToken } from "@utils/storage"
import { useContext, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useCustomNavigate } from "./useCustomNavigate"

export const useInitialAccessRedirect = () => {
  const { arrayPath } = useContext(KContext)
  const { navigate } = useCustomNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (arrayPath?.[1] === EUrlPath.EMERGENCY_ACCESS) {
      const emrAccessToken = getToken("EmergencyAccess")
      if (emrAccessToken) return
      return navigate(`/${EUrlPath.EMERGENCY_ACCESS}/${arrayPath?.[2]}/welcome`)
    }
    if (pathname === "/") return navigate("/user")
  }, [])
}
